import React from 'react';

export default function XIcon(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg
      width="4rem"
      height="4rem"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g
        style={{
          scale: '0.1',
          transform: 'translate(-45px, -47px)'
        }}>
        <ellipse
          ry="155.5"
          rx="155.5"
          id="svg_7"
          cy="200"
          cx="200"
          fill="#747474"
        />
        <ellipse id="svg_8" cy="278.5" cx="89" stroke="#000" fill="#077474" />
        <line
          transform="rotate(30 200 200)"
          id="svg_10"
          y2="313.05419"
          x2="199.99999"
          y1="86.94581"
          x1="199.99999"
          strokeWidth="20"
          stroke="#ffffff"
          fill="none"
        />
        <line
          transform="rotate(-30 200 200)"
          id="svg_11"
          y2="313.0542"
          x2="200"
          y1="86.94582"
          x1="200"
          strokeWidth="20"
          stroke="#ffffff"
          fill="none"
        />
      </g>
    </svg>
  );
}
